import CharacterCard from "./CharacterCard";

export default CharacterCard;
